import { render, staticRenderFns } from "./AppRegistationStep.vue?vue&type=template&id=03dee236&"
import script from "./AppRegistationStep.vue?vue&type=script&lang=js&"
export * from "./AppRegistationStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports